import createApiClient, { REACT_APP_ATC_API_URL, REACT_APP_API_URL } from './apiClient';

// Fetch data from the API using GET method
export const fetchData = async (endpoint: string, headers: any, serviceType: any, params: any = {}): Promise<any> => {
    let apiClient = createApiClient(serviceType === 'atc' ? REACT_APP_ATC_API_URL : REACT_APP_API_URL);
    try {
        const response = await apiClient.get(endpoint, headers);
        // Check for an empty `data` field
        if (response.headers['content-type'] === 'application/octet-stream') {
            return response;
        }
        if (!response.data || Object.keys(response.data).length === 0) {
            throw new Error('Empty response data received');
        }
        return response; // Return the valid response
    } catch (error: any) {
        console.error('Error in fetchData:', error.message || error);

        // Throw a meaningful error message
        throw new Error(error.response?.data?.message || 'Failed to fetch data from the API');
    }
};

// Post data to the API using POST method
export const postData = async (endpoint: string, data: any, headers: any, serviceType: any): Promise<any> => {
    try {
        let apiClient = createApiClient(serviceType === 'atc' ? REACT_APP_ATC_API_URL : REACT_APP_API_URL);
        const response = await apiClient.post(endpoint, data, headers);
        return response;
    } catch (error) {
        return error;
    }
};

export const postDataV2 = async (endpoint: string, data: any, headers: any, serviceType: any) => {
    const apiClient = createApiClient(serviceType === 'atc' ? REACT_APP_ATC_API_URL : REACT_APP_API_URL, true);
    const response = await apiClient.post(endpoint, data, headers);

    return response;
};
